import React from 'react';
import {Card, Grid, Image} from 'semantic-ui-react';

import {makeDBContentImageUrl} from 'utils/DBUtils';

class BreakCardGroup extends React.Component {

  render() {

    let brkArray = [];
    for (var i=0; i<this.props.item.numBreaks; i++) {
      brkArray.push({});
    }

    return  <Grid columns={this.props.item.numBreaks}>
              <Grid.Row>
                { brkArray.map((brk, i) => (
                  <Grid.Column>
                    <Card fluid>
                      <Image  src={makeDBContentImageUrl('bc555aa2-b9f1-44b1-bb03-e3753d02a739')} />
                      <Card.Content>
                        <Card.Header>Sweater Weather Is Here -- Which of These Sweaters Matches Your Fall Personality?</Card.Header>
                        <Card.Meta>Sponsored</Card.Meta>
                      </Card.Content>
                    </Card>
                  </Grid.Column>
                ))}
              </Grid.Row>
            </Grid>
  }

}

export default BreakCardGroup;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/break-card-group.jsx